module.exports = __webpack_public_path__ + "img/Groupleft.d64b6413.png";